export default __webpack_public_path__ + "static/media/logo.367f04f3.png";